/**
 * V0 Collection Filter with AJAX API
 * Shopify AJAX APIとURLパラメータを使用してフィルタリング＋ページネーション実装
 * 認証不要・全商品対応・競合サイト同等の絞り込み検索機能
 */

(function() {
  'use strict';

  // フィルター状態
  let filterState = {
    contentType: 'all',
    gender: 'all',
    age: 'all',
    duration: 'all',
    resolution: 'all',
    aiTool: 'all'
  };

  // ケバブケースをキャメルケースに変換
  function kebabToCamel(str) {
    return str.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
  }

  // フィルター状態からURLパラメータを生成
  function buildFilterParams() {
    const params = new URLSearchParams();

    // コンテンツタイプ（AI生成）
    if (filterState.contentType === 'ai') {
      params.append('filter.p.m.vsozai.ai_generated', 'true');
    } else if (filterState.contentType === 'real') {
      params.append('filter.p.m.vsozai.ai_generated', 'false');
    }

    // 性別
    if (filterState.gender !== 'all') {
      params.append('filter.p.m.vsozai.person_gender', filterState.gender);
    }

    // 年代
    if (filterState.age !== 'all') {
      params.append('filter.p.m.vsozai.person_age_group', filterState.age);
    }

    // 動画の長さ
    if (filterState.duration !== 'all') {
      const category = filterState.duration === 'short' ? '10秒未満' : '10秒以上';
      params.append('filter.p.m.vsozai.duration_category', category);
    }

    // 解像度
    if (filterState.resolution !== 'all') {
      params.append('filter.p.m.vsozai.resolution_class', filterState.resolution);
    }

    // AIツール
    if (filterState.aiTool !== 'all') {
      // AI生成フィルターも有効化
      params.append('filter.p.m.vsozai.ai_generated', 'true');
      params.append('filter.p.m.vsozai.ai_tool', filterState.aiTool);
    }

    return params.toString();
  }

  // フィルター適用してページ遷移
  function applyFilters() {
    const collectionPath = window.location.pathname; // e.g., /collections/cooking-food
    const filterParams = buildFilterParams();

    // フィルターパネルが開いていることを記録
    localStorage.setItem('filterPanelOpen', '1');

    // URLパラメータ付きでリロード
    if (filterParams) {
      window.location.href = `${collectionPath}?${filterParams}`;
    } else {
      // フィルターなし
      window.location.href = collectionPath;
    }
  }

  // URLパラメータからフィルター状態を復元
  function restoreFiltersFromURL() {
    const params = new URLSearchParams(window.location.search);

    // AI生成
    const aiGenerated = params.get('filter.p.m.vsozai.ai_generated');
    if (aiGenerated === 'true') {
      filterState.contentType = 'ai';
    } else if (aiGenerated === 'false') {
      filterState.contentType = 'real';
    }

    // 性別
    const gender = params.get('filter.p.m.vsozai.person_gender');
    if (gender) {
      filterState.gender = gender;
    }

    // 年代
    const age = params.get('filter.p.m.vsozai.person_age_group');
    if (age) {
      filterState.age = age;
    }

    // 動画の長さ
    const durationCategory = params.get('filter.p.m.vsozai.duration_category');
    if (durationCategory === '10秒未満') {
      filterState.duration = 'short';
    } else if (durationCategory === '10秒以上') {
      filterState.duration = 'medium';
    }

    // 解像度
    const resolution = params.get('filter.p.m.vsozai.resolution_class');
    if (resolution) {
      filterState.resolution = resolution;
    }

    // AIツール
    const aiTool = params.get('filter.p.m.vsozai.ai_tool');
    if (aiTool) {
      filterState.aiTool = aiTool;
    }

    // UIに反映
    updateFilterUI();
  }

  // フィルターUIを更新
  function updateFilterUI() {
    document.querySelectorAll('[data-filter]').forEach(input => {
      const filterTypeKebab = input.getAttribute('data-filter');
      const filterType = kebabToCamel(filterTypeKebab);
      const currentValue = filterState[filterType];

      if (input.value === currentValue) {
        input.checked = true;
      }
    });
  }

  // フィルター変更ハンドラー
  function handleFilterChange(filterType, value) {

    filterState[filterType] = value;

    // フィルター適用（ページリロード）
    applyFilters();
  }

  // ページネーションリンクにフィルターパラメータを追加
  function updatePaginationLinks() {
    const filterParams = buildFilterParams();
    if (!filterParams) return;

    // すべてのページネーションリンクを取得
    document.querySelectorAll('.v0-pagination a').forEach(link => {
      const href = link.getAttribute('href');
      if (!href) return;

      // 既存のURLにフィルターパラメータを追加
      const url = new URL(href, window.location.origin);
      const params = new URLSearchParams(filterParams);

      // フィルターパラメータをURLに追加
      params.forEach((value, key) => {
        url.searchParams.set(key, value);
      });

      link.setAttribute('href', url.pathname + url.search);
    });

  }

  // フィルターパネルを自動的に開く
  function restoreFilterPanelState() {
    const shouldOpen = localStorage.getItem('filterPanelOpen');
    if (shouldOpen === '1') {
      // パネルを開く
      const panel = document.getElementById('filters-panel');
      if (panel) {
        panel.style.display = 'block';
      }
    }
  }

  // 初期化
  function init() {

    // URLからフィルター状態を復元
    restoreFiltersFromURL();

    // フィルターパネルの状態を復元
    // restoreFilterPanelState(); // Disabled: Always start with filter panel closed

    // フィルターUIにイベントリスナー追加
    document.querySelectorAll('[data-filter]').forEach(input => {
      input.addEventListener('change', (e) => {
        const filterTypeKebab = e.target.getAttribute('data-filter');
        const filterType = kebabToCamel(filterTypeKebab);
        const value = e.target.value;
        handleFilterChange(filterType, value);
      });
    });

    // ページネーションリンクを更新
    updatePaginationLinks();

  }

  // DOMContentLoaded後に初期化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // グローバルに公開（デバッグ用）
  window.V0FilterAJAX = {
    filterState,
    applyFilters,
    buildFilterParams
  };
})();
